// extracted by mini-css-extract-plugin
module.exports = {"social_media_div":"SocialMedia_social_media_div__1zPfH","icon_button":"SocialMedia_icon_button__3mUqo"};